import React from 'react';

import {
  Tooltip as TooltipBs,
  OverlayTrigger
} from 'react-bootstrap';

// 若未給定child表示做為內部mask，此情況下父元素的position需設定為relative

const Tooltip = props => {

  const tooltip = <TooltipBs id="tooltip">{props.tipText}</TooltipBs>;
  let overlayTrigger = "";

  if (props.child) {
    overlayTrigger = (
      <OverlayTrigger placement={props.placement || 'top'} overlay={tooltip} onClick={props.onClick}>
        {props.child}
      </OverlayTrigger>
    );
  } else {
    overlayTrigger = (
      <OverlayTrigger placement={props.placement || 'top'} overlay={tooltip} onClick={props.onClick || (e => { })}>
        <div style={{ position: "absolute", top: 0, left: 0, width: '100%', height: '100%', display: 'inline-block', backgroundColor: 'transparent' }}></div>
      </OverlayTrigger>
    )
  }

  return overlayTrigger;
};

Tooltip.propTypes = {
  tipText: React.PropTypes.string.isRequired,
}

export default Tooltip;






// WEBPACK FOOTER //
// ./src/commonComponents/Tooltip.jsx